"use client";
import React, { useState } from "react";
import Header from "components/common/Header";
import Footer from "components/common/Footer";
import {
  Hero,
  Benefits,
  Steps,
  RegisterSection,
  PartnerForm,
  type PartnerFormValues,
  type SubmitState,
} from "components/partner";
import { useT } from "providers/I18nProvider";

/**
 * Landing "Hợp tác với chúng tôi" (/hop-tac).
 * Container chỉ giữ logic gửi form; UI từng section ở components/partner/*.
 * Form POST /api/partner → Google Sheet (Apps Script). Server validate lại + rate-limit + honeypot.
 */

const PartnerContainer: React.FC = () => {
  const t = useT();
  const [state, setState] = useState<SubmitState>({ status: "idle" });

  /** Map mã lỗi API → câu báo cho chủ cơ sở */
  const errorMessage = (code: string | undefined, httpStatus: number): string => {
    if (code === "NOT_CONFIGURED") return t("partner.errNotConfigured");
    if (code === "INVALID_PHONE") return t("partner.errInvalidPhone");
    if (httpStatus === 429) return t("partner.errTooMany");
    return t("partner.errGeneric");
  };

  const submit = async (values: PartnerFormValues) => {
    try {
      const res = await fetch("/api/partner", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
      const json = await res.json().catch(() => ({}));
      if (res.ok && json?.ok) {
        setState({ status: "success" });
        return;
      }
      setState({ status: "error", errorMsg: errorMessage(json?.error, res.status) });
    } catch {
      setState({
        status: "error",
        errorMsg: t("partner.errNetwork"),
      });
    }
  };

  return (
    <>
      <Header />
      <main className="bg-white">
        <Hero />
        <Benefits />
        <Steps />
        <RegisterSection>
          <PartnerForm state={state} onSubmit={submit} onReset={() => setState({ status: "idle" })} />
        </RegisterSection>
      </main>
      <Footer />
    </>
  );
};

export default PartnerContainer;
